import React from "react";
import "./footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Footer Links */}
      <div className="footer-content">
        <div className="footer-col">
          <h3>Company</h3>
          <ul>
            <li><a href="#">About FRS</a></li>
            <li><a href="#">Our Advisors</a></li>
            <li><a href="#">Investors</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>Our Services</h3>
          <ul>
            <li><a href="#">FIRE Robotics Labs</a></li>
            <li><a href="#">Workshops</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>Events</h3>
          <ul>
            <li><a href="#">Techkriti, IIT Kanpur</a></li>
            <li><a href="#">Techfest, IIT Bombay</a></li>
            <li><a href="#">N.E.F.</a></li>
            <li><a href="#">Cyber Symphony</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>Support</h3>
          <ul>
            <li><a href="#">Contact Us</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>Resources</h3>
          <ul>
            <li><a href="#">Blogs</a></li>
            <li><a href="#">Video</a></li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-flags">
          <span>🇮🇳 India</span>
          <span>🇳🇵 Nepal</span>
          <span>🇸🇬 Singapore</span>
          <span>🇵🇭 Philippines</span>
          <span>🇦🇪 U.A.E</span>
        </div>

        <div className="footer-copy">
          © FIZ Robotic Solutions Pvt Ltd, {currentYear}{" "} | {" "}
          <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">
            Terms of use
          </a>{" "}
          |{" "}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{" "}
          |{" "}
          <a href="/cookie-consent" target="_blank" rel="noopener noreferrer">
            Cookie Consent
          </a>
        </div>

        <div className="footer-socials">
          <a href="#" aria-label="Facebook">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="#" aria-label="YouTube">
            <i className="bi bi-youtube"></i>
          </a>
          <a href="#" aria-label="Instagram">
            <i className="bi bi-instagram"></i>
          </a>
          <a href="#" aria-label="LinkedIn">
            <i className="bi bi-linkedin"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
